<div class="overflow-auto" [style.maxHeight]="maxHeight ?? 'none'">
  <span class="b2 regular label">{{ containerTitle | bmsTranslate }}</span>
  <vdw-selection-list [options]="selectListOptions" (optionsChanged)="onSelectOptionChanged($event)"></vdw-selection-list>
</div>
